<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row class="mt-3">
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="getExpandClasses(u)"
						v-for="(u, uindex) in parkingRemovalList" v-bind:key="`lcrpr` + uindex + renderCounter">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img :src="LaneClosureRequest.getLaneImage100(u.parkingLaneId.value)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ LaneClosureRequest.getLaneText(u.parkingLaneId.value) }}
									<br />
									<small>{{ u.parkingStartAddress.value }} to {{
										u.parkingEndAddress.value }}</small>
									<small>&nbsp;({{ u.parkingRemovalMetres.value }} metres) </small>
									<br />
								</div>
								<div class="collapsible-heading__edit"></div>
								<button type="button" class="collapsible-heading__edit_parking" title="Edit Lane"
									@click="onEditOne(uindex, u)"><font-awesome-icon icon="edit" /></button>

								<button type="button" class="collapsible-heading__remove" title="Remove Lane"
									@click="openConfirmationModal(uindex)"><font-awesome-icon icon="trash" /></button>
							</div>
						</div>
					</div>
					<!-- End of desktop -->

					<div v-if="$store.state.isMobile"
						:class="isExpanded(u) ? 'collapsible expanded collapsible__lane' : 'collapsible collapsible__lane collapsed'"
						v-for="(u, uindex) in parkingRemovalList" v-bind:key="`lcrpr` + uindex + '-' + renderCounter">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image">
									<b-img :src="LaneClosureRequest.getLaneImage100(u.parkingLaneId.value)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title">
									{{ LaneClosureRequest.getLaneText(u.parkingLaneId.value) }}
									<div class="collapsible-heading__subtitle">{{ u.parkingStartAddress.value }} to {{
										u.parkingEndAddress.value }}</div>
									<div class="collapsible-heading__subtitle">({{ u.parkingRemovalMetres.value }} metres)
									</div>
								</div>
								<button type="button" class="collapsible-heading__remove" title="Edit Lane"
									@click="onEditOne(uindex, u)"><font-awesome-icon icon="edit" /></button>
								<button type="button" class="collapsible-heading__remove" title="Remove Lane"
									@click="openConfirmationModal(uindex)"><font-awesome-icon icon="trash" /></button>
							</div>
						</div>
					</div>
					<!-- End of mobile -->

					<confirmation-modal ref="confirmationModal" @action-confirmed="onRemoveOne"
						:confirmText="'Deletion of lanes from parking removal is irreversible! Are you sure you want to remove this lane?'"></confirmation-modal>

				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import ConfirmationModal from './ConfirmationModal.vue';

export default {
	name: 'LaneClosureRequestParkingRemovalListing',
	props: ['renderCounter', 'parkingRemovalList'],
	components: {
		ConfirmationModal,
	},
	data() {
		return {
			LaneClosureRequest: LaneClosureRequest,
			laneIndexToRemove: null,
		}
	},
	mounted() {

	},
	destroyed() {
	},
	watch: {


	},
	computed: {


	},
	methods: {

		getExpandClasses(obj) {
			if (obj) {
				if (obj.expand) {
					return "collapsible expanded collapsible__lane";
				}
			}
			return "collapsible collapsible__lane collapsed";
		},
		isExpanded(u) {
			if (u) {
				if (typeof u.expand != "undefined") {
					return u.expand;
				}
			}
			return false;
		},
		classes: function (index, uindex) {
			if (this.isEntry(index, uindex)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		openConfirmationModal(index) {
			if (index != null) {
				this.laneIndexToRemove = index;
				this.$refs.confirmationModal.openModal();
			}
		},
		onRemoveOne(index) {
			// Use the passed index to remove the item from the parkingRemoval array
			this.$emit('delete-parking-removal-button-clicked', this.laneIndexToRemove);
		},
		onEditOne(index, laneInfoToEdit) {
			if (laneInfoToEdit != null) {
				// Emit the event and send the lane to edit
				this.$emit('edit-parking-removal-button-clicked', index, laneInfoToEdit);
			}
		},

	}
}
</script>
